<template>
    <!-- 选择题 -->
    <!-- 选择题 -->
    <div>
        <template v-if="sid==21">
            <div class="choose">
                <p class="title_t">
                    <span v-if="ask_length>1"
                          class="num">({{question.number}})</span>
                    <span v-if="question.subject.content"
                          :class="{'title_p':ask_length>1}"
                          v-html="question.subject.content"></span>
                    <img v-if="question.subject.image"
                         :src="question.subject.image" />
                </p>
                <ul v-if="question.options.length">
                    <li v-for="option in question.options"
                        :class="{'li_right':(option.is_right),'li_wrong':(question.user_answer == option.option)}"
                        :key="option.id">

                        <i>{{option.option}}</i>
                        <p>
                            <span v-if="option.content"
                                  v-html="option.content"></span>
                            <img class="option_img"
                                 :src="option.image"
                                 v-if="option.image" />
                        </p>
                    </li>
                </ul>
            </div>
        </template>
        <template v-else>
            <div class="choose">
                <ul v-if="question.options.length">
                    <li v-for="option in question.options"
                        :class="{'li_right':type&&option.is_right} "
                        :key="option.id">
                        <i>{{option.option}}</i>
                        <p>
                            <span v-if="option.content.content"
                                  v-html="option.content.content"></span>
                            <img class="option_img"
                                 :src="option.content.image_url"
                                 v-if="option.content.image_url" />
                        </p>
                    </li>
                </ul>
            </div>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
// checked
export default {
    props: ['question', 'askLength', 'number', 'sid', 'type'],
    //mystatus 1 不显示展开
    data () {
        return {
        }
    },
    components: {

    },
    computed: {
        ask_length () {
            return this.askLength ? this.askLength : 1
        },
        // mytask(){
        // 	return this.mystatus?1:0;
        // }

    },
    beforeRouteLeave (to, from, next) {
    },
    mounted () {

    },
    methods: {
    },
    created () {

    },
    destroyed () {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title_t {
    background: #fff;
    // padding: 24px/$ppr 0;
    line-height: 48px / $ppr;
    // border-bottom: #E8E8E8 1px/$ppr solid;
    position: relative;
    word-break: break-all;
    word-wrap: break-word;
    display: block;
    width: 600px / $ppr;
    span {
        display: inline-block;
        vertical-align: top;
    }
    .title_p {
        width: 90%;
        display: inline-block;
        // padding-left:50px/$ppr;
        word-break: break-all;
        word-wrap: break-word;
    }
    > img {
        display: inline-block;
    }
}
.Supervisor {
    color: hsl(222, 82%, 65%);
}
.choose {
    background: #fff;
    // margin-top: 24px/$ppr;
    ul {
        display: block;
        width: 600px / $ppr;
        margin: 0 auto;
        li {
            padding: 24px / $ppr;
            line-height: 48px / $ppr;
            color: #333;
            display: block;
            background: #f7f8f9;
            margin-bottom: 40px / $ppr;
            border-radius: 16px / $ppr;
            vertical-align: middle;
            &:last-child {
                margin-bottom: 0;
            }
            i {
                display: inline-block;
                width: 40px / $ppr;
                // text-align: center;
            }
            p {
                display: inline-block;
                width: 460px / $ppr;
                padding-left: 30px / $ppr;
                vertical-align: middle;
                border-left: 1px solid #d0d3d6;
                img {
                    display: inline-block;
                    max-width: 460px / $ppr;
                }
                .option_img {
                    display: block;
                }
            }
            &.li_wrong {
                color: #ff5a5a;
                background: #fbf0ee;
                i {
                    border-radius: 1px solid #ff5a5a;
                }
                p {
                    border-left: 1px solid #ff5a5a;
                }
            }
            &.li_right {
                color: #2bc8a0;
                background: #eefaf8;
                i {
                    border-radius: 1px solid #2bc8a0;
                }
                p {
                    border-left: 1px solid #2bc8a0;
                }
            }
        }
        &.inspect_myColor {
            i {
                &.i_equal {
                    border: #5d89ef 1px / $ppr solid;
                    background: #5d89ef;
                }
                &.i_noequal {
                    border: #e8e8e8 1px / $ppr solid;
                }
            }
            p {
                &.p_equal {
                    color: #5d89ef;
                }
            }
        }
    }
    .p {
        padding: 24px / $ppr;
        line-height: 48px / $ppr;
        border-bottom: #e8e8e8 1px / $ppr solid;
        min-height: 48px / $ppr;
    }
    position: relative;
    .taskbottom {
        line-height: 96px / $ppr;
        height: 96px / $ppr;
        padding: 0 24px / $ppr;
        font-size: 24px / $ppr;
        color: #aaa;
        position: relative;
        span:nth-of-type(2) {
            line-height: 50px / $ppr;
            text-align: center;
            width: 120px / $ppr;
            height: 50px / $ppr;
            position: absolute;
            top: 20px / $ppr;
            right: 20px / $ppr;
            border-radius: 50px / $ppr;
            border: 1px / $ppr solid #e8e8e8;
            &.Select {
                color: #5e89ef;
                border: 1px / $ppr solid #5e89ef;
            }
            &.remove {
                color: #ff6600;
                border: 1px / $ppr solid #ff6600;
            }
        }
    }
}
</style>
